"use client";

import React from "react";

interface StandardCardProps {
  title?: string;
  headerAction?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const StandardCard: React.FC<StandardCardProps> = ({ 
  title, 
  headerAction, 
  children, 
  className = "" 
}) => {
  return (
    <div className={`border border-border rounded-lg overflow-hidden bg-card ${className}`}>
      {title && (
        <div className="flex items-center justify-between px-4 py-3 bg-muted/50 border-b border-border">
          <h3 className="text-sm font-medium text-primary uppercase tracking-wider">{title}</h3>
          {headerAction}
        </div>
      )}
      <div className="p-4">
        {children}
      </div>
    </div>
  );
};

export default StandardCard;